// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgreementModalController from "./agreement_modal_controller"
application.register("agreement-modal", AgreementModalController)

import BenefitModalController from "./benefit_modal_controller"
application.register("benefit-modal", BenefitModalController)

import BulkJobEntryStatusController from "./bulk_job_entry_status_controller"
application.register("bulk-job-entry-status", BulkJobEntryStatusController)

import CheckboxAllController from "./checkbox_all_controller"
application.register("checkbox-all", CheckboxAllController)

import CitySelectorController from "./city_selector_controller"
application.register("city-selector", CitySelectorController)

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import CompanyController from "./company_controller"
application.register("company", CompanyController)

import EmployerNoteController from "./employer_note_controller"
application.register("employer-note", EmployerNoteController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FooterButtonController from "./footer_button_controller"
application.register("footer-button", FooterButtonController)

import GuestUserBarController from "./guest_user_bar_controller"
application.register("guest-user-bar", GuestUserBarController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import HeaderSearchSpController from "./header_search_sp_controller"
application.register("header-search-sp", HeaderSearchSpController)

import HomeScreenGuideController from "./home_screen_guide_controller"
application.register("home-screen-guide", HomeScreenGuideController)

import ImageUploadFormController from "./image_upload_form_controller"
application.register("image-upload-form", ImageUploadFormController)

import JobDetailNavController from "./job_detail_nav_controller"
application.register("job-detail-nav", JobDetailNavController)

import JobEntryStatusController from "./job_entry_status_controller"
application.register("job-entry-status", JobEntryStatusController)

import JobFilter__MainController from "./job_filter/main_controller"
application.register("job-filter--main", JobFilter__MainController)

import JobFilter__ModalController from "./job_filter/modal_controller"
application.register("job-filter--modal", JobFilter__ModalController)

import JobFilter__SpOccupationModalController from "./job_filter/sp_occupation_modal_controller"
application.register("job-filter--sp-occupation-modal", JobFilter__SpOccupationModalController)

import JobFilter__SpWorkPlaceModalController from "./job_filter/sp_work_place_modal_controller"
application.register("job-filter--sp-work-place-modal", JobFilter__SpWorkPlaceModalController)

import JobFormCompanySelectController from "./job_form_company_select_controller"
application.register("job-form-company-select", JobFormCompanySelectController)

import JobFormStep1Controller from "./job_form_step1_controller"
application.register("job-form-step1", JobFormStep1Controller)

import JobFormStep2Controller from "./job_form_step2_controller"
application.register("job-form-step2", JobFormStep2Controller)

import JobFormStep3Controller from "./job_form_step3_controller"
application.register("job-form-step3", JobFormStep3Controller)

import JobFormStep4Controller from "./job_form_step4_controller"
application.register("job-form-step4", JobFormStep4Controller)

import JobImageSwiperController from "./job_image_swiper_controller"
application.register("job-image-swiper", JobImageSwiperController)

import JobWorkPlaceController from "./job_work_place_controller"
application.register("job-work-place", JobWorkPlaceController)

import LeaveConfirmationController from "./leave_confirmation_controller"
application.register("leave-confirmation", LeaveConfirmationController)

import Modal__CloseController from "./modal/close_controller"
application.register("modal--close", Modal__CloseController)

import Modal__OpenController from "./modal/open_controller"
application.register("modal--open", Modal__OpenController)

import NoticeDismissalController from "./notice_dismissal_controller"
application.register("notice-dismissal", NoticeDismissalController)

import PreventEnterSubmitController from "./prevent_enter_submit_controller"
application.register("prevent-enter-submit", PreventEnterSubmitController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import RelayController from "./relay_controller"
application.register("relay", RelayController)

import ReportLinkController from "./report_link_controller"
application.register("report-link", ReportLinkController)

import SendingController from "./sending_controller"
application.register("sending", SendingController)

import SpecialConditionModalController from "./special_condition_modal_controller"
application.register("special-condition-modal", SpecialConditionModalController)

import SubmitHandlerController from "./submit_handler_controller"
application.register("submit-handler", SubmitHandlerController)

import UnderageConfirmController from "./underage_confirm_controller"
application.register("underage-confirm", UnderageConfirmController)

import Validator__TextareaCounterController from "./validator/textarea_counter_controller"
application.register("validator--textarea-counter", Validator__TextareaCounterController)

import TweetRecommendController from "./tweet_recommend_controller"
application.register("tweet-recommend", TweetRecommendController)
